"use client";
import PhotoSwipeLightbox from 'photoswipe/lightbox';
import 'photoswipe/style.css';
import { useEffect, useState } from 'react';
import Image from 'next/image'

const imageLoader = ({ src, width, quality }: { src: string; width: number; quality?: number }) => {
  return `${src.includes('?') ? `${src}&` : `${src}?`}auto=format&w=${width}&q=${quality || 75}`;
};

export default function QuoteImage({
  image,
  imageWidth,
  imageHeight,
}: {
  image: string;
  imageWidth: string;
  imageHeight: string;
}) {

  const [imageLoaded, setImageLoaded] = useState<boolean>(false);

  useEffect(() => {
    const lightbox: PhotoSwipeLightbox = new PhotoSwipeLightbox({
      gallery: '#gallery',
      children: 'a',
      pswpModule: () => import('photoswipe'),
    });
    lightbox.init();

    return () => {
      lightbox.destroy();
    };
  }, []);

  useEffect(() => {
    setImageLoaded(false);
  }, [image]);
  return (
    <div className="pswp-gallery w-full" id="gallery">
      <a
        id="img_href"
        href={`${image.includes('?') ? `${image}&` : `${image}?`}auto=format&q=80&w=3840`}
        data-pswp-width={imageWidth}
        data-pswp-height={imageHeight}
        target="_blank"
        rel="nofollow"
      >
        <div className="relative w-full h-full">
          {!imageLoaded && <div className="absolute inset-0 animate-pulse bg-gray-300"></div>}
          <Image
            src={image}
            loader={imageLoader}
            width={parseInt(imageWidth)}
            height={parseInt(imageHeight)}
            sizes="(max-width: 768px) 100vw, (max-width: 1200px) 50vw, 33vw"
            priority={true}
            fetchPriority='high'
            alt="Inspirational Image"
            className="relative"
            onLoad={() => {
              setImageLoaded(true);
            }}
          />
        </div>
      </a>
    </div>
  );
}